/** Prefer the SPA catalog so purpose names stay Latin Serbian even if the API lags. */
export function purposeLabel(t: (key: string) => string, value: string, fallback?: string) {
  const key = `logbook.purposes.${value}`;
  const translated = t(key);
  return translated === key ? (fallback ?? value) : translated;
}
